/**
 * Classify page_templates rows — email/order fragments vs editor-insertable page HTML.
 */

export function isEmailTemplateKey(key) {
  return key && String(key).startsWith('email-');
}

export function isOrderCannedTemplateKey(key) {
  return key && String(key).startsWith('order-canned-');
}

/** Templates shown in Simple Editor → Insert Template (tune pages, articles, etc.). */
export function isInsertablePageTemplateKey(key) {
  if (!key) return false;
  if (isEmailTemplateKey(key)) return false;
  if (isOrderCannedTemplateKey(key)) return false;
  return true;
}

export function slugFromOrderCannedKey(key) {
  return String(key || '').replace(/^order-canned-/, '');
}

/** Filter API rows or a keyed object to insertable page templates only. */
export function filterInsertablePageTemplates(templates) {
  if (Array.isArray(templates)) {
    return templates.filter((t) => isInsertablePageTemplateKey(t.template_key || t.templateKey));
  }
  if (templates && typeof templates === 'object') {
    return Object.fromEntries(
      Object.entries(templates).filter(([key]) => isInsertablePageTemplateKey(key))
    );
  }
  return templates;
}
